import React, { Fragment } from 'react';

import Input from '@common-components/form/new/Input';
import { SimpleDate } from '@common-components/form/date/simpleDateField';
import { INPUT_TYPES } from '@common-components/form/constants/fieldTypes';

const RenderNameComponent = ({ values, handleChange, handleBlur, handleFocus, readOnly=false }) => {
    return (
        <Fragment>
            <Input
                label={{
                    labelText:'label.first_name',
                    labelClasses: ['gi-input__label--col', 'grid-col-12'],
                    wrapperClasses: ['gi-input--col', 'grid-col-4'],
                    isRequired: true
                }}
                input={{
                    id: 'fist_name',
                    name: 'firstName',
                    inputClasses: ['grid-col-12'],
                    type: INPUT_TYPES.TEXT,
                    value: values.firstName,
                    readOnly: readOnly,
                    maxLength: 60,
                    isInputRequired: true
                }}
                actions={{
                    handleFieldChange: value => handleChange({ target: { value, name:'firstName' } }),
                    handleFieldBlur: value => handleBlur({ target: { value, name:'firstName' } }),
                    handleFieldFocus: value => handleFocus({ target: { value, name:'firstName' } }),
                }}
            />

            <Input
                label={{
                    labelText:'label.last_name',
                    labelClasses: ['gi-input__label--col', 'grid-col-12'],
                    wrapperClasses: ['gi-input--col', 'grid-col-4'],
                    isRequired: true
                }}
                input={{
                    id: 'last_name',
                    name: 'lastName',
                    inputClasses: ['grid-col-12'],
                    type: INPUT_TYPES.TEXT,
                    value: values.lastName,
                    readOnly: readOnly,
                    maxLength: 60,
                    isInputRequired: true
                }}
                actions={{
                    handleFieldChange: value => handleChange({ target: { value, name:'lastName' } }),
                    handleFieldBlur: value => handleBlur({ target: { value, name:'lastName' } }),
                    handleFieldFocus: value => handleFocus({ target: { value, name:'lastName' } })
                }}
            />
        </Fragment>
    );
};

const RenderDOBComponent = ({ values, handleChange, handleBlur, readOnly=false }) => {
    return (
        <Fragment>
            <SimpleDate
                label={{
                    labelText:'label.dob',
                    labelClasses: ['gi-ssn__label--col', 'grid-col-12'],
                    wrapperClasses: ['grid-row','grid-col-4'],
                    isRequired: true
                }}
                input={{
                    id: 'dob_name',
                    name: 'dob_name',
                    inputClasses: ['grid-col-12', 'margin-t-5-ve'],
                    type: INPUT_TYPES.TEXT,
                    placeholder:'MM/DD/YYYY',
                    value: values.dob_name,
                    readOnly: readOnly,
                    isInputRequired: true
                }}
                actions={{
                    handleFieldChange: handleChange,
                    handleFieldBlur: handleBlur
                }}
            />
        </Fragment>
    );
};

export { RenderNameComponent, RenderDOBComponent };